import { fromJS, List } from 'immutable';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';
import {
    GET_SUPPORT_TICKETS,
    SUPPORT_TICKETS_CHANGED,
    SET_LOADING,
    SET_ERROR
} from "../constants/support.constants";

export const initialState = fromJS({
    data: [],
    fetched: false,
    loading: false,
    error: null
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case AUTH_SUCCESS:
            return initialState;
        case GET_SUPPORT_TICKETS:
            return state.set('loading', true);
        case SET_LOADING:
            return state.set('loading', action.loading);
        case SET_ERROR:
            return state.set('error', action.error);
        case SUPPORT_TICKETS_CHANGED:
            return state
                .set('loading', false)
                .set('data', List(action.tickets))
                .set('fetched', true)
                .set('error', null);
        default:
            return state;
    }
}
